module.exports = __webpack_public_path__ + "img/title.3d7db1ae.png";